module.exports = __webpack_public_path__ + "img/en.85a97dab.svg";